import React, {useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from '@mui/material';
import {useLocation, useNavigate} from "react-router-dom";
import Strings from "../../assets/strings";
import {deleteAccount} from "../../services";
import {userLogout} from "../../redux/reducers/authReducer";
import {useAppDispatch} from "../../redux/hooks";
import LoadingProgress from "../../components/LoadingProgress";

export default function DeleteAccount() {
    let navigate = useNavigate();
     const { state }:{state:any} = useLocation()
    const dispatch = useAppDispatch();

    const [motivo, setMotivo] = useState("");
    const [loading, setLoading] = useState(false);
    const confirm = () => {
        setLoading(true)
        deleteAccount(motivo).then(()=>{
            dispatch(userLogout())
        }).finally(()=>setLoading(false))

    };

    return (
        <div>
            <Dialog
                open={Boolean(state?.confirmDeleteAccount)}
                onClose={()=>navigate(-1)}
                fullWidth
                maxWidth={"xs"}
            >
                <DialogTitle id="alert-dialog-title">Eliminar Cuenta</DialogTitle>
                <DialogContent>
                    {loading && <LoadingProgress />}
                    <Typography>Seguro que deseas eliminar esta cuenta?</Typography>
                    <Typography  variant={"body2"} marginBottom={2}>Todos sus datos se eliminaran definitivamente.</Typography>

                    <TextField multiline label={"Motivo"}
                               fullWidth
                               value={motivo}
                               onChange={({target})=>setMotivo(target.value)}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>navigate(-1)} disabled={loading} variant={"text"} color={"warning"}>
                        {Strings.cancelar}
                    </Button>
                    <Button onClick={confirm} color="error"  disabled={loading} variant={"outlined"}>
                        {Strings.confirmar}
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    );
}
